import { useState } from 'react';
import { useIsMobile } from '../utils';

// Modal de una sola vez para mostrar los 10 códigos de recuperación de MFA
// recién generados (#122). No se cierra al hacer click afuera ni tiene X:
// solo se cierra tildando la casilla de confirmación — cerrarlo sin guardar
// los códigos los pierde para siempre.
export default function RecoveryCodesModal({ codes, onClose }) {
  const isMobile = useIsMobile();
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);

  const text = codes.join('\n');

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownload = () => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'openbackup-codigos-recuperacion.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)',
    }}>
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        width: isMobile ? '95vw' : 480, maxHeight: isMobile ? '90vh' : '85vh',
        overflowY: 'auto',
        clipPath: 'polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px))',
      }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 13, letterSpacing: 1, textTransform: 'uppercase' }}>
            Códigos de recuperación de MFA
          </span>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{
            background: 'rgba(255,77,109,0.1)', border: '1px solid var(--red)', color: 'var(--red)',
            padding: '10px 14px', fontSize: 12, fontFamily: 'var(--mono)', marginBottom: 16,
          }}>
            Esta es la ÚNICA vez que vas a ver estos códigos. Guardalos en un lugar
            seguro — cada uno sirve una sola vez si perdés el acceso a tu app
            autenticadora.
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 8,
            background: 'var(--bg)', border: '1px solid var(--border)', padding: 16, marginBottom: 16,
          }}>
            {codes.map((code, i) => (
              <div key={i} style={{ fontFamily: 'var(--mono)', fontSize: 14, letterSpacing: 1, color: 'var(--accent)' }}>
                {code}
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 }}>
            <button onClick={handleCopy} style={{
              background: 'transparent', border: '1px solid var(--accent)', color: 'var(--accent)',
              padding: '8px 16px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer', letterSpacing: 1,
            }}>
              {copied ? '✓ COPIADO' : 'COPIAR TODOS'}
            </button>
            <button onClick={handleDownload} style={{
              background: 'transparent', border: '1px solid var(--border)', color: 'var(--text)',
              padding: '8px 16px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer', letterSpacing: 1,
            }}>
              DESCARGAR .TXT
            </button>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20, cursor: 'pointer' }}>
            <input type="checkbox" checked={saved} onChange={e => setSaved(e.target.checked)} style={{ width: 16, height: 16, cursor: 'pointer' }} />
            <span style={{ fontSize: 12, fontFamily: 'var(--mono)', color: 'var(--text)' }}>
              Los guardé en un lugar seguro
            </span>
          </label>

          <button
            onClick={onClose}
            disabled={!saved}
            style={{
              width: '100%', background: saved ? 'var(--accent)' : 'var(--accent2)',
              color: 'var(--bg)', border: 'none', padding: 14, fontFamily: 'var(--mono)',
              fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase',
              cursor: saved ? 'pointer' : 'not-allowed', opacity: saved ? 1 : 0.5,
            }}
          >
            ENTENDIDO, CONTINUAR →
          </button>
        </div>
      </div>
    </div>
  );
}
